import { OrdersService } from '../../../services/OrdersService';

export const formatOrderAmount = (amount: number) =>
    new Intl.NumberFormat('uk-UA', {
        style: 'currency',
        currency: 'UAH',
        maximumFractionDigits: 2,
    }).format(amount);

export const deliveryMethodLabel = (method: string) =>
    OrdersService.getDeliveryMethodLabel(method);
